module.exports = __webpack_public_path__ + "img/专利证书12_能效在线评估云平台v1.0.2b2dae7c.png";